import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_9: FaireProductEntity = {
  token: "nyc-bev-9",
  type: "product",
  name: "Organic Iced Coffee",
  brandName: "Cold Brew NYC",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/02d67b5d3eb10a7b21cf9ba2a5a2c158f485d138d388b6279609aa1c3b2b6d56.webp",
  priceDollars: 11,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/02d67b5d3eb10a7b21cf9ba2a5a2c158f485d138d388b6279609aa1c3b2b6d56.webp",
  weight: 1.4,
  dimensions: {
    width: 3,
    height: 9,
    depth: 3,
  },
  description: "Fresh-pressed apple cider from Hudson Valley",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "organic"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
